import * as React from "react";
import type { SVGProps } from "react";
const SvgUpload02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19.785 3.577a2.1 2.1 0 0 0-1.485-.62H5.7c-.557 0-1.091.223-1.485.62M12 21.043v-12m0 0-4.8 4.586m4.8-4.586 4.8 4.586"
    />
  </svg>
);
export default SvgUpload02;
